import {Component, Input, OnChanges} from '@angular/core';
import {ShorePower} from "@portbase/bezoekschip-service-typescriptmodels";

@Component({
  selector: 'app-shore-power-details',
  templateUrl: './shore-power-details.component.html',
  styleUrls: ['./shore-power-details.component.css'],
  standalone: false
})
export class ShorePowerDetailsComponent implements OnChanges {

  @Input() shorePower: ShorePower;

  pinCodeReceived: boolean

  ngOnChanges() {
    this.pinCodeReceived = (this.shorePower.pinCode != null);
  }
}
